import React from 'react';
import './Academics.css';

const Academics = () => {
  return (
    <div className="academics">
      {/* Hero Section */}
      <section className="academics-hero">
        <div className="container">
          <h1>Academic Excellence</h1>
          <p className="hero-subtitle">Comprehensive Education for Every Student</p>
        </div>
      </section>

      {/* Curriculum Overview */}
      <section className="curriculum-overview">
        <div className="container">
          <h2>Our Curriculum</h2>
          <div className="curriculum-content">
            <p>
              At The MINT School, we follow a comprehensive curriculum that combines 
              the Nigerian educational standards with international best practices. 
              Our curriculum is designed to develop critical thinking, creativity, 
              and practical skills that prepare students for success in higher 
              education and beyond.
            </p>
            <div className="curriculum-features">
              <div className="feature">
                <span className="feature-icon">📚</span>
                <span>Nigerian Curriculum (UBE)</span>
              </div>
              <div className="feature">
                <span className="feature-icon">🌍</span>
                <span>International Standards</span>
              </div>
              <div className="feature">
                <span className="feature-icon">💡</span>
                <span>Critical Thinking Focus</span>
              </div>
              <div className="feature">
                <span className="feature-icon">🎯</span>
                <span>Practical Application</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Academic Levels */}
      <section className="academic-levels">
        <div className="container">
          <h2>Academic Levels</h2>
          <div className="levels-grid">
            <div className="level-card">
              <div className="level-icon">👶</div>
              <h3>Early Years</h3>
              <div className="level-details">
                <h4>Nursery & Kindergarten</h4>
                <p>Ages 2-5 years</p>
                <ul>
                  <li>Play-based learning</li>
                  <li>Basic literacy & numeracy</li>
                  <li>Social skills development</li>
                  <li>Creative expression</li>
                </ul>
              </div>
            </div>

            <div className="level-card">
              <div className="level-icon">🎒</div>
              <h3>Primary Education</h3>
              <div className="level-details">
                <h4>Primary 1-6</h4>
                <p>Ages 6-11 years</p>
                <ul>
                  <li>Core subjects (English, Math, Science)</li>
                  <li>Social studies & History</li>
                  <li>Arts & Physical Education</li>
                  <li>Computer literacy</li>
                </ul>
              </div>
            </div>

            <div className="level-card">
              <div className="level-icon">🎓</div>
              <h3>Junior Secondary</h3>
              <div className="level-details">
                <h4>JSS 1-3</h4>
                <p>Ages 12-14 years</p>
                <ul>
                  <li>Core subjects + electives</li>
                  <li>Basic Technology</li>
                  <li>Business Studies</li>
                  <li>Agricultural Science</li>
                </ul>
              </div>
            </div>

            <div className="level-card">
              <div className="level-icon">🏆</div>
              <h3>Senior Secondary</h3>
              <div className="level-details">
                <h4>SSS 1-3</h4>
                <p>Ages 15-17 years</p>
                <ul>
                  <li>Science & Arts streams</li>
                  <li>WAEC & NECO preparation</li>
                  <li>Career guidance</li>
                  <li>Leadership development</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Subjects */}
      <section className="subjects">
        <div className="container">
          <h2>Core Subjects</h2>
          <div className="subjects-grid">
            <div className="subject-category">
              <h3>Languages</h3>
              <div className="subject-list">
                <div className="subject-item">English Language</div>
                <div className="subject-item">Literature in English</div>
                <div className="subject-item">French</div>
                <div className="subject-item">Hausa</div>
              </div>
            </div>

            <div className="subject-category">
              <h3>Sciences</h3>
              <div className="subject-list">
                <div className="subject-item">Mathematics</div>
                <div className="subject-item">Physics</div>
                <div className="subject-item">Chemistry</div>
                <div className="subject-item">Biology</div>
                <div className="subject-item">Agricultural Science</div>
              </div>
            </div>

            <div className="subject-category">
              <h3>Social Sciences</h3>
              <div className="subject-list">
                <div className="subject-item">History</div>
                <div className="subject-item">Geography</div>
                <div className="subject-item">Government</div>
                <div className="subject-item">Economics</div>
                <div className="subject-item">Civic Education</div>
              </div>
            </div>

            <div className="subject-category">
              <h3>Arts & Technology</h3>
              <div className="subject-list">
                <div className="subject-item">Fine Arts</div>
                <div className="subject-item">Music</div>
                <div className="subject-item">Computer Studies</div>
                <div className="subject-item">Basic Technology</div>
                <div className="subject-item">Physical Education</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Assessment */}
      <section className="assessment">
        <div className="container">
          <h2>Assessment & Evaluation</h2>
          <div className="assessment-content">
            <div className="assessment-methods">
              <div className="method-card">
                <div className="method-icon">📝</div>
                <h3>Continuous Assessment</h3>
                <p>Regular tests, assignments, and projects throughout the term to monitor student progress.</p>
              </div>
              <div className="method-card">
                <div className="method-icon">📊</div>
                <h3>Terminal Examinations</h3>
                <p>Comprehensive end-of-term examinations to evaluate overall understanding and retention.</p>
              </div>
              <div className="method-card">
                <div className="method-icon">🎯</div>
                <h3>Standardized Tests</h3>
                <p>Preparation for WAEC, NECO, and other national examinations.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Extracurricular */}
      <section className="extracurricular">
        <div className="container">
          <h2>Extracurricular Activities</h2>
          <div className="activities-grid">
            <div className="activity-card">
              <div className="activity-icon">⚽</div>
              <h3>Sports & Athletics</h3>
              <ul>
                <li>Football</li>
                <li>Basketball</li>
                <li>Track & Field</li>
                <li>Table Tennis</li>
                <li>Volleyball</li>
              </ul>
            </div>

            <div className="activity-card">
              <div className="activity-icon">🎭</div>
              <h3>Arts & Culture</h3>
              <ul>
                <li>Drama Club</li>
                <li>Music Band</li>
                <li>Art Club</li>
                <li>Debate Society</li>
                <li>Cultural Dance</li>
              </ul>
            </div>

            <div className="activity-card">
              <div className="activity-icon">🔬</div>
              <h3>Academic Clubs</h3>
              <ul>
                <li>Science Club</li>
                <li>Mathematics Society</li>
                <li>Literary Society</li>
                <li>Computer Club</li>
                <li>Quiz Club</li>
              </ul>
            </div>

            <div className="activity-card">
              <div className="activity-icon">🤝</div>
              <h3>Leadership & Service</h3>
              <ul>
                <li>Student Government</li>
                <li>Environmental Club</li>
                <li>Community Service</li>
                <li>Peer Mentoring</li>
                <li>Volunteer Programs</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Academic Calendar */}
      <section className="academic-calendar">
        <div className="container">
          <h2>Academic Calendar</h2>
          <div className="calendar-content">
            <div className="term-info">
              <div className="term-card">
                <h3>First Term</h3>
                <p>September - December</p>
                <div className="term-details">
                  <span>Duration: 13 weeks</span>
                  <span>Mid-term break: 1 week</span>
                </div>
              </div>
              <div className="term-card">
                <h3>Second Term</h3>
                <p>January - April</p>
                <div className="term-details">
                  <span>Duration: 13 weeks</span>
                  <span>Mid-term break: 1 week</span>
                </div>
              </div>
              <div className="term-card">
                <h3>Third Term</h3>
                <p>May - July</p>
                <div className="term-details">
                  <span>Duration: 10 weeks</span>
                  <span>Final examinations</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Academics;
